import {
  checkboxClasses,
  CheckboxProps,
  SvgIcon,
  SvgIconProps,
} from '@mui/material';
import { Theme } from '@mui/material/styles';

const Icon = (props: SvgIconProps) => (
  <SvgIcon fontSize="inherit" viewBox="0 0 24 24" {...props}>
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      fill="white"
      stroke="#DFE3E8"
      strokeWidth="2"
      rx="4"
    />
  </SvgIcon>
);

const CheckedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon fontSize="inherit" viewBox={`0 0 24 24`} {...props}>
      <rect
        x="1"
        y="1"
        width="22"
        height="22"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        rx="4"
      />
      <path
        fill="white"
        d="m9.55 18l-5.7-5.7l1.425-1.425L9.55 15.15l9.175-9.175L20.15 7.4z"
      />
    </SvgIcon>
  );
};

const IndeterminateIcon = (props: SvgIconProps) => (
  <SvgIcon fontSize="inherit" viewBox="0 0 24 24" {...props}>
    <rect
      x="1"
      y="1"
      width="22"
      height="22"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      rx="4"
    />
    <rect x="6" y="11" width="12" height="2" fill="white" />
  </SvgIcon>
);

export default function Checkbox(theme: Theme) {
  const rootStyles = (ownerState: CheckboxProps) => {
    const smallSize = ownerState.size === 'small';
    const mediumSize = ownerState.size === 'medium';
    const largeSize = ownerState.size === 'large';

    const defaultStyle = {
      // padding: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
      '&:hover': {},
    };

    const size = {
      // ...(smallSize && {
      //   padding: theme.spacing(1.5),
      //   maxWidth: 12,
      //   maxHeight: 12,
      //   [`& > svg`]: {
      //     width: 12,
      //     height: 12,
      //   },
      // }),
      ...(smallSize && {
        padding: theme.spacing(1.5),
        maxWidth: 16,
        maxHeight: 16,
        [`& > svg`]: {
          width: 16,
          height: 16,
          // borderRadius: theme.spacing(0.5),
        },
      }),
      ...((mediumSize || largeSize) && {
        padding: theme.spacing(1.5),
        maxWidth: 20,
        maxHeight: 20,
        [`& > svg`]: {
          width: 20,
          height: 20,
          // borderRadius: theme.spacing(0.5),
        },
      }),
    };

    const focusedStyle = {
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary[500]}`,
      },
    };

    const disabledStyle = {
      [`&.${checkboxClasses.disabled}>svg`]: {
        backgroundColor: theme.palette.grey[300],
        borderRadius: theme.spacing(0.5),
      },
      [`&.${checkboxClasses.disabled}&.${checkboxClasses.checked}`]: {
        color: theme.palette.primary[200],
      },
      [`&.${checkboxClasses.disabled}&.${checkboxClasses.indeterminate}`]: {
        color: theme.palette.primary[200],
      },
    };

    return { ...defaultStyle, ...size, ...focusedStyle, ...disabledStyle };
  };
  return {
    MuiCheckbox: {
      defaultProps: {
        size: 'small',
        icon: <Icon />,
        checkedIcon: <CheckedIcon />,
        indeterminateIcon: <IndeterminateIcon />,
        disableRipple: true,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: CheckboxProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
